import adminApi from '../../apis/adminApi';

export function editBanner(id, values) {
  return adminApi.put(`/api/admin/banners/${id}`, values).then((res) => res.data);
}

export function getBanner(id) {
  return adminApi.get(`/api/admin/banners/${id}`).then((res) => res.data);
}

export function addBanner(values) {
  return adminApi.post('/api/admin/banners', values).then((res) => res.data);
}
